"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";

import "./FahrgestellnummerPruefen.css";
import "@/common/Common.css";
import { TopSection } from "./sections/TopSection";
import { fragenFahrgestellNummer } from "./data";
import { Banner } from "@/common/Banner";

// Die text- und linktragenden Bloecke werden SERVERSEITIG gerendert (dynamic
// OHNE die SSR-Abschaltung, Playbook 2.6 / KEYWORD-PLAN Cluster A Phase A):
// Bis hierher standen ~1.100 Woerter Erklaerinhalt, drei h2-Abschnitte und die
// 11 FAQ-Eintraege aus data.js in KEINEM Server-HTML — fuer Bing, GPTBot und
// ClaudeBot bestand die staerkste Seite der Domain nur aus dem Formular.
// Code-Splitting bleibt erhalten: `dynamic` erzeugt auch ohne die
// SSR-Abschaltung weiterhin einen eigenen Chunk. Client-only bleiben nur die
// Bloecke mit Browser-/Auth-Bindung (FindFinPopup, AnmeldenSection).
const CheckValueSell = dynamic(() =>
  import("./sections/CheckValueSell").then((m) => m.CheckValueSell)
);
const BannerSections = dynamic(() =>
  import("./sections/BannerSections").then((m) => m.BannerSections)
);
const Nutzen = dynamic(() => import("./sections/Nutzen").then((m) => m.default));
const Buchen = dynamic(() => import("./sections/Buchen").then((m) => m.Buchen));
const HäufigeFragen = dynamic(() =>
  import("@/common/HäufigeFragen").then((m) => m.HäufigeFragen)
);
// Ratgeber wird SERVERSEITIG gerendert (dynamic OHNE ssr:false, Playbook/
// KEYWORD-PLAN SSR-Strategie): die "Mehr zum Thema"-Kacheln tragen interne
// Links (u. a. auf /fahrgestellnummer-pruefen/was-ist-die-fin) und muessen
// im Server-HTML stehen — Code-Splitting bleibt erhalten.
const Ratgeber = dynamic(() =>
  import("@/components/Ratgeber/Ratgeber").then((m) => m.default)
);
const FindFinPopup = dynamic(
  () => import("@/components/FindFinPopup/FindFinPopup").then((m) => m.default),
  { ssr: false }
);

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function FahrgestellnummerPruefen() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  const [selectedFin, setSelectedFin] = useState("");
  const [isValidFIN, setIsValidFIN] = useState(false);
  const [validKmStand, setValidKmStand] = useState(true);
  const [isFindFinPopupOpen, setIsFindFinPopupOpen] = useState(false);

  return (
    <div className="home-container">
      {isFindFinPopupOpen && (
        <FindFinPopup
          isOpen={isFindFinPopupOpen}
          onClose={() => setIsFindFinPopupOpen(false)}
        />
      )}

      {step !== 13 && (
        <TopSection
          step={step}
          setStep={setStep}
          selectedBrand={selectedBrand}
          setSelectedBrand={setSelectedBrand}
          selectedModel={selectedModel}
          setSelectedModel={setSelectedModel}
          selectedYear={selectedYear}
          setSelectedYear={setSelectedYear}
          selectedBauform={selectedBauform}
          setSelectedBauform={setSelectedBauform}
          selectedFuel={selectedFuel}
          setSelectedFuel={setSelectedFuel}
          selectedVariant={selectedVariant}
          setSelectedVariant={setSelectedVariant}
          selectedPs={selectedPs}
          setSelectedPs={setSelectedPs}
          selectedTransmission={selectedTransmission}
          setSelectedTransmission={setSelectedTransmission}
          selectedDoors={selectedDoors}
          setSelectedDoors={setSelectedDoors}
          setSelectedModelType={setSelectedModelType}
          selectedModelType={selectedModelType}
          selectedKmStand={selectedKmStand}
          setSelectedKmStand={setSelectedKmStand}
          selectedFin={selectedFin}
          setSelectedFin={setSelectedFin}
          isValidFIN={isValidFIN}
          setIsValidFIN={setIsValidFIN}
          validKmStand={validKmStand}
          setValidKmStand={setValidKmStand}
          setIsFindFinPopupOpen={setIsFindFinPopupOpen}
        />
      )}

      {step === 13 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={selectedFin || null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/fahrgestellnummer-pruefen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 13 && (
        <>
          <div className="Page background-color">
            <div className="Page-wrapper">
              <CheckValueSell />
              <BannerSections />
            </div>
          </div>
          <Nutzen />

          <div className="Page background-color">
            <div className="Page-wrapper">
              <Buchen />

              <HäufigeFragen
                hideImage
                fragen={fragenFahrgestellNummer}
                removePaddingTop
                title="Häufig gestellte Fragen über die Fahrgestellnummer"
              />

              <Ratgeber
                title="Mehr zum Thema Fahrgestellnummer prüfen"
                wasIstDieFin
                autoBewerten
                autoVerkaufen
                listenpreisBerechnen
                wasistmeinautowert
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default FahrgestellnummerPruefen;
